var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"b tw-mx-auto tw-mt-8 tw-max-w-2xl"},[_vm._m(0),_vm._v(" "),_c(_setup.PasswordResetRequestForm)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',[_c('h1',{staticClass:"tw-text-center tw-font-sans tw-text-3xl tw-font-bold tw-text-gray-900"},[_vm._v("\n      Password Reset\n    ")])])
}]

export { render, staticRenderFns }